<template>
    <div class="margin_horizontal">
        <div class="pageTitle">
            <span class="md-title">{{ $t("management.team.title") }}</span>
        </div>
        <div class="table_head table_head_filter">
            <md-button class="md-blank" @click="showUserDetails({})" v-if="canAddUsers">
                <span class>+</span>
                {{$t("management.team.add.button")}}
            </md-button>
        </div>
        <div>
            <div class="flex filter_table">
                <div class="flex flex_column w_100">
                    <AgItem :rowData="rowData"
                            :columnDefs="columnDefs"
                            :frameworkComponents="frameworkComponents"
                            v-on:sortChanged="sortChanged"
                    />
                    <Pagination
                        :totalNum="totalNum"
                        :pageSize="pageSize"
                        :sizeChange="sizeChange"
                        :currentChange="currentChange"
                        :currentPage="page"
                    ></Pagination>
                </div>
                <FilterUser @apply-filter="applyFilter"/>
            </div>
        </div>
        <ManageUserModal ref="manageModal" @change="getList"></ManageUserModal>
    </div>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import FilterUser from "./FilterUser";
import UsersTableOperation from "@/components/templates/users/usersOperationCol.js";
import {traderTeamManagementApi} from "@/common/api/traderTeamManagementApi";
import {enumDef} from "@/common/enumDefs";
import Pagination from "@/components/templates/common/Pagination";
import PaginationParent from "@/components/templates/common/PaginationParent";
import ManageUserModal from "@/components/templates/modal/users/ManageUserModal";

export default {
    extends: PaginationParent,
    components: {
        ManageUserModal,
        FilterUser,
        UsersTableOperation,
        AgItem,
        Pagination
    },
    data() {
        return {
            frameworkComponents: {
                opCellRender: UsersTableOperation
            },
            rowData: null,
            filters: [],
            sorting: [],
            columnDefs: [
                {
                    field: "id",
                    hide: true
                },
                {
                    headerName: this.$t("management.team.table.header.lastName"),
                    field: "lastName",
                    sortable: true
                },
                {
                    headerName: this.$t("management.team.table.header.firstName"),
                    field: "firstName",
                    sortable: true
                },
                {
                    headerName: this.$t("management.team.table.header.email"),
                    field: "email",
                    sortable: true
                },
                {
                    headerName: this.$t("management.team.table.header.phone"),
                    field: "phone",
                    sortable: true
                },
                {
                    headerName: this.$t("management.team.table.header.role"),
                    field: "userLevel",
                    cellRendererFramework: "EnumAsText",
                    enumDef: enumDef.userLevel,
                    sortable: true
                },
                {
                    headerName: this.$t("management.team.table.header.status"),
                    field: "userStatus",
                    cellRendererFramework: "EnumAsText",
                    enumDef: enumDef.userStatus,
                    sortable: true
                },
                {
                    headerName: this.$t("common.actions"),
                    minWidth: 100,
                    maxWidth: 150,
                    pinned: "right",
                    cellRenderer: "opCellRender",
                    cellRendererParams: {
                        showUserDetails: this.showUserDetails,
                        showPermissions: this.showPermissions,
                        handOver: this.confirmHandOver,
                        sendActivationMail: this.confirmSendActivationMail
                    }
                }
            ],
        };
    },
    beforeMount() {
        this.getList();
    },
    computed: {
        canAddUsers() {
            return [enumDef.userLevel.RootUser, enumDef.userLevel.ManagerUser].includes(this.currentUser.level);
        }
    },
    methods: {
    sortChanged(sortData) {
      this.sorting = sortData;
      this.initPage();
      this.getList();
    },
        getList() {
            let postData = {
                columns: [],
                filters: this.filters || [],
                maxResults: this.maxResults,
                offset: this.offset,
                sorting: this.sorting,
            };

            traderTeamManagementApi.inspection.listUsers(postData)
                .then(res => {
                    if (res) {
                        this.setTotalNum(res.recordsTotal);
                        this.rowData = res.data;
                    }
                })
                .catch(e => {
                    this.toast(e);
                });
        },
        applyFilter(filters) {
            this.filters = filters;
            this.getList();
        },
        showUserDetails(data) {
            this.$refs.manageModal.showUserDetails(data);
        },
        confirmSendActivationMail(data) {
            this.confirmMeg({
                msg: this.$t("management.team.table.operation.sendActivationMail.confirm"),
                confirmFun: this.sendActivationMail,
                params: data
            }, true);
        },
        sendActivationMail(data) {
            traderTeamManagementApi.operation.sendUserActivationMail(data.id)
                .then(() => {
                    this.toastSuccess();
                })
                .catch((e) => {
                    this.toast(e);
                });
        },
        showPermissions(data) {
            this.$refs.manageModal.showPermissions(data);
        },
        confirmHandOver(data) {
            this.confirmMeg({
                msg: this.$t("management.team.table.operation.handOver.confirm"),
                confirmFun: this.handOver,
                params: data
            }, true);
        },
        handOver(data) {
            traderTeamManagementApi.operation.handOver(this.currentUser.userId, data.id)
                .then(() => {
                    this.logout();
                })
                .catch((e) => {
                    this.toast(e);
                });
        }
    }
};
</script>
